export class OrderProduct
{
	orderProductId: number;
	orderProductDate: Date;
	listPrice: any;
	useBookingRule: any;
	applyStaysOfAtLeastNts: any;
	applyStaysOfLessThanNts: any;
	addToRate: any;
	active: any;
	feeType: any;
	feeFrequency: any;
}
